import { render, staticRenderFns } from "./leftBar.vue?vue&type=template&id=524393d8"
import script from "./leftBar.vue?vue&type=script&lang=js"
export * from "./leftBar.vue?vue&type=script&lang=js"
import style0 from "./leftBar.vue?vue&type=style&index=0&id=524393d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports